const formDataConfig = {
  mental_age: "",
  family_values: "",
  traditions_of_family: "",
  family_member_details: "",
  legacy_of_family: "",
  emotional_range: "",
  thoughts_about: "",
  conversation_style: "",
  working_style: "",
  spending_style: "",
  thoughts_on_lifestyle: "",
  past_vacations: "",
  physical_looks: "",
  disfigurements: "",
  internal_organs_health: "",
  personality: "",
  dressing: "",
  behaviour_in_sg: "",
  area_of_livig: "",
  how_many_transfer: "",
  idea_of_settle: "",
  areas_of_interest: "",
  possession: "",
  future_travel: "",
  marks: "",
  courses_apart: "",
  areas_of_success: "",
  activities_involved: "",
  leadership_position: "",
  typing_speed: "",
  interesting_subjects: "",
  current_occupation: "",
  interest_in_occupation: "",
  work_designation: "",
  interact_with_coworkers: "",
  nature_of_job: "",
  relation_with: "",
  issues_in_family: "",
  circle_of_frnds: "",
  number_of_partners: "",
  fluency_in_lang: "",
  interest_in_other_lang: "",
  caste: "",
  faiths: "",
  beliefs: "",
  no_of_cars: "",
  no_of_house: "",
  financial_literacy: "",
  views_on_invest: "",
  How_many_debts: "",
  comfort_with_tech: "",
  electronic_devices: "",
  appliances_in_use: "",
  technological_interests: "",
  how_often_chge_devices: "",
  traditional_items: "",
  types_of_brands: "",
  volunteer_services: "",
  fears: "",
  motivations_drawbacks: "",
  free_time: "",
  outings: "",
};

export default formDataConfig;
